/* Modulo: Review Spotlight — spotlight peek carousel + per-card read more.
   Vanilla IIFE, theme-editor aware, reduced-motion aware. No deps.
   Uses window.moduloLazyInit when present, otherwise inits eagerly. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(el) {
    if (!el || el.dataset.moduloTspInit === '1') return; // idempotent — editor re-renders
    el.dataset.moduloTspInit = '1';

    var rail = el.querySelector('[data-modulo-tsp-rail]');
    if (!rail) return;

    var prev = el.querySelector('[data-modulo-tsp-prev]');
    var next = el.querySelector('[data-modulo-tsp-next]');
    var dotsHost = el.querySelector('[data-modulo-tsp-dots]');

    var readMoreOn = el.getAttribute('data-read-more') === 'true';
    var moreLabel = el.getAttribute('data-read-more-label') || 'Read more';
    var lessLabel = el.getAttribute('data-read-less-label') || 'Read less';

    function cards() { return Array.prototype.slice.call(rail.querySelectorAll('.modulo-tsp__card')); }

    // ─── center detection → spotlight + dot/arrow sync ───
    var activeIndex = 0;
    function updateActive() {
      var list = cards();
      if (!list.length) return;
      var center = rail.scrollLeft + rail.clientWidth / 2;
      var best = 0, bestD = Infinity;
      for (var i = 0; i < list.length; i++) {
        var cc = list[i].offsetLeft + list[i].clientWidth / 2;
        var d = Math.abs(cc - center);
        if (d < bestD) { bestD = d; best = i; }
      }
      activeIndex = best;
      for (var j = 0; j < list.length; j++) list[j].classList.toggle('is-active', j === best);
      if (dotsHost) {
        var dots = dotsHost.children;
        for (var k = 0; k < dots.length; k++) {
          var on = k === best;
          dots[k].classList.toggle('is-active', on);
          dots[k].setAttribute('aria-selected', on ? 'true' : 'false');
        }
      }
      if (prev) prev.disabled = best <= 0;
      if (next) next.disabled = best >= list.length - 1;
    }

    function scrollToCard(i) {
      var list = cards();
      var c = list[Math.max(0, Math.min(i, list.length - 1))];
      if (!c) return;
      var left = c.offsetLeft - (rail.clientWidth - c.clientWidth) / 2;
      rail.scrollTo({ left: left, behavior: REDUCE ? 'auto' : 'smooth' });
    }

    var raf = null;
    rail.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; updateActive(); });
    });

    if (prev) prev.addEventListener('click', function () { scrollToCard(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { scrollToCard(activeIndex + 1); });

    // ─── dots (built to match card count) ───
    if (dotsHost) {
      dotsHost.innerHTML = '';
      cards().forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'modulo-tsp__dot';
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', 'Go to review ' + (i + 1));
        d.addEventListener('click', function () { scrollToCard(i); });
        dotsHost.appendChild(d);
      });
    }

    // ─── read more / less — per card, only the clicked card expands ───
    function setupReadMore() {
      if (!readMoreOn) return;
      cards().forEach(function (c) {
        var text = c.querySelector('.modulo-tsp__text');
        var btn = c.querySelector('[data-modulo-tsp-more]');
        if (!text || !btn) return;
        if (!c.classList.contains('is-expanded')) {
          btn.textContent = moreLabel;
          // only offer when the clamped text actually overflows
          btn.hidden = (text.scrollHeight - text.clientHeight) <= 2;
        }
        if (!btn.dataset.wired) {
          btn.dataset.wired = '1';
          btn.addEventListener('click', function () {
            var open = c.classList.toggle('is-expanded');
            btn.textContent = open ? lessLabel : moreLabel;
            if (raf) window.cancelAnimationFrame(raf);
            raf = window.requestAnimationFrame(function () { raf = null; updateActive(); });
          });
        }
      });
    }

    // ─── resize (debounced, removable) ───
    var resizeT;
    function onResize() {
      window.clearTimeout(resizeT);
      resizeT = window.setTimeout(function () { setupReadMore(); updateActive(); }, 120);
    }
    window.addEventListener('resize', onResize);

    el.moduloTspTeardown = function () {
      window.removeEventListener('resize', onResize);
      el.dataset.moduloTspInit = '';
    };

    // engage spotlight styling (no-JS / pre-hydration kept all cards equal)
    rail.classList.add('is-ready');
    window.requestAnimationFrame(function () {
      setupReadMore();
      updateActive();
    });
  }

  function initAll() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-tsp]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-tsp]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  function sectionTarget(e) {
    var t = e.target;
    if (!t || !t.querySelector) return null;
    if (t.matches && t.matches('[data-modulo-tsp]')) return t;
    return t.querySelector('[data-modulo-tsp]');
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = sectionTarget(e);
    if (el) initSection(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = sectionTarget(e);
    if (el && typeof el.moduloTspTeardown === 'function') el.moduloTspTeardown();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
